module.exports = __webpack_public_path__ + "img/s1.0.1.0_202602051651.jpg";